"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL_MAP = void 0;
exports.URL_MAP = {
    athenaeum: '/r/the-athenaeum/',
    giftGuide: '/c/gift-guide/',
    myAccount: '/my-account',
    checkout: '/checkout',
    error: '/r/error',
    toc: '/r/terms',
    home: '/',
};
//# sourceMappingURL=url.js.map